import { observer } from 'mobx-react-lite'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { type IIconsVector } from 'shared/ui/Icon'
import { type CountrySelectStore } from 'shared/ui/CountrySelect/store/CountrySelectStore'
import styles from './styles.module.scss'

type ICountrySelectProps = {
  store: CountrySelectStore
}

export const CountrySelect = observer(({ store }: ICountrySelectProps) => {
  const { countries, country, countryData, setCountry } = store

  return (
    <SelectField
      labelText='Country'
      value={country}
      items={countries}
      setValue={setCountry}
      className={styles.countrySelect}
      selectProps={{
        dropdownProps: {
          margin: -40,
          withSearch: false,
          withTextInput: false,
          ariaLabel: 'Country',
        },
      }}
      btnProps={{
        size: 'extraLarge',
        className: styles.textField,
        text: countryData ? countryData.name : 'Select',
        textIcon: countryData ? (countryData.flag as IIconsVector) : undefined,
      }}
    />
  )
})
